/*
  Dasom Essence — dual-currency display (CA$ / US$) + US waitlist.
  Display-only: US visitors can SEE US prices and join a shipping waitlist; checkout stays
  CAD (we are not selling to the US yet, so this adds zero US tax/duty/MoCRA exposure).
  No Shopify Markets needed. Prices are FIXED (a configurable CAD->USD rate, rounded clean),
  so US numbers do not float with FX. Tune SELECTORS to the live theme during staging.

  Config (set in the snippet before this script):
    window.DASOM_USD_RATE      e.g. 0.73   (CAD -> USD)
    window.DASOM_PRICE_SELECTORS  array of CSS selectors for price elements
    window.DASOM_WAITLIST_ENDPOINT  optional POST url for emails (else shows thanks only)
*/
(function () {
  'use strict';
  var RATE = window.DASOM_USD_RATE || 0.73;
  var SELECTORS = window.DASOM_PRICE_SELECTORS || [
    '.price-item--regular', '.price-item--sale', '.price__regular .price-item',
    '[data-product-price]', '.product__price', '.price .money'
  ];
  var KEY = 'dasom_ccy';
  var ccy = (function () { try { return localStorage.getItem(KEY) || 'CAD'; } catch (e) { return 'CAD'; } })();

  function roundUsd(n) { return Math.round(n); } // clean whole-dollar US prices
  function parseAmount(t) { var m = (t || '').replace(/,/g, '').match(/(\d+(?:\.\d+)?)/); return m ? parseFloat(m[1]) : null; }

  function priceEls() {
    var set = [];
    SELECTORS.forEach(function (s) { try { document.querySelectorAll(s).forEach(function (e) { set.push(e); }); } catch (x) {} });
    return set;
  }

  var mo = null;
  function setText(el, val) { if (el.textContent !== val) el.textContent = val; }
  function apply() {
    // Disconnect the observer for the duration of our own DOM writes so they can
    // never retrigger us (setting textContent IS a childList mutation when the
    // element had child nodes — the old `applying` flag did not actually block this,
    // because observer callbacks fire as async microtasks after the flag resets).
    if (mo) mo.disconnect();
    priceEls().forEach(function (el) {
      if (el.getAttribute('data-cad') === null) {
        var a0 = parseAmount(el.textContent);
        if (a0 === null) return;
        el.setAttribute('data-cad', el.textContent.trim());
        el.setAttribute('data-cad-amt', String(a0));
      }
      var cad = el.getAttribute('data-cad'); var amt = parseFloat(el.getAttribute('data-cad-amt'));
      if (ccy === 'USD' && !isNaN(amt)) setText(el, 'US$' + roundUsd(amt * RATE));
      else setText(el, cad);
    });
    var t = document.getElementById('dz-ccy-label'); if (t) t.textContent = ccy === 'USD' ? 'US $' : 'CA $';
    var bar = document.getElementById('dz-us-bar'); if (bar) bar.style.display = ccy === 'USD' ? 'flex' : 'none';
    if (mo) mo.observe(document.body, { childList: true, subtree: true });
  }
  // coalesce bursts of DOM activity into at most one apply per frame-ish window
  var t_deb = null;
  function scheduleApply() { if (t_deb) return; t_deb = setTimeout(function () { t_deb = null; apply(); }, 300); }

  function setCcy(c) { ccy = c; try { localStorage.setItem(KEY, c); } catch (e) {} apply(); }

  function init() {
    var toggle = document.getElementById('dz-ccy-toggle');
    if (toggle) toggle.addEventListener('click', function () { setCcy(ccy === 'USD' ? 'CAD' : 'USD'); });
    var wl = document.getElementById('dz-wl-form');
    if (wl) wl.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = wl.querySelector('input').value.trim(); if (!email) return;
      var done = function () { wl.innerHTML = '<p class="dz-wl-thanks">Thank you. We will email you the moment we ship to the US, with a launch offer.</p>'; };
      var ep = window.DASOM_WAITLIST_ENDPOINT;
      if (ep) { try { fetch(ep, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email, list: 'us-waitlist' }) }).then(done).catch(done); } catch (x) { done(); } }
      else { done(); }
    });
    apply();
    // re-apply on Shopify dynamic renders (variant change, section load, cart).
    // The observer is disconnected during apply() (above) and bursts are debounced,
    // so page-wide DOM activity can never peg the CPU or feed back into itself.
    document.addEventListener('shopify:section:load', scheduleApply);
    mo = new MutationObserver(scheduleApply);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
